import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables'
import axios from 'axios';

const API_URL = global.SET_API_URL + 'sr/'

export const getItemWiseSalesReport = createAsyncThunk('iwsr/giwsr', async (targetedData, thunkAPI) => {
  try {
    const response = await axios.post(API_URL + 'getItemWiseSalesReport', targetedData);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    return thunkAPI.rejectWithValue(message)
  }
});

export const getFilteredItemWiseSalesReport = createAsyncThunk('iwsr/gfiwsr', async (targetedData, thunkAPI) => {
  try {
    const response = await axios.post(API_URL + 'getFilteredItemWiseSalesReport', targetedData);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    return thunkAPI.rejectWithValue(message)
  }
});

export const getFilteredItemWiseSalesDeepDetailReport = createAsyncThunk('iwsr/gfiwsddr', async (targetedData, thunkAPI) => {
  try {
    const response = await axios.post(API_URL + 'getFilteredItemWiseSalesDeepDetailReport', targetedData);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    return thunkAPI.rejectWithValue(message)
  }
});

export const getItemWiseSalesReportForOpening = createAsyncThunk('iwsr/giwsrfo', async (targetedData, thunkAPI) => {
  try {
    const response = await axios.post(API_URL + 'getItemWiseSalesReportForOpening', targetedData);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    return thunkAPI.rejectWithValue(message)
  }
});

const itemWiseSalesSlice = createSlice({
  name: 'itemWiseSales',
  initialState: {
    reportData: [],
    deepDetailData: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getItemWiseSalesReport.fulfilled, (state, action) => {
        state.reportData = action.payload;
      })
      .addCase(getFilteredItemWiseSalesReport.fulfilled, (state, action) => {
        state.reportData = action.payload;
      })
      .addCase(getFilteredItemWiseSalesDeepDetailReport.fulfilled, (state, action) => {
        state.deepDetailData = action.payload;
      })
      .addCase(getItemWiseSalesReportForOpening.fulfilled, (state, action) => {
        state.reportData = action.payload;
      })
  }
});

export default itemWiseSalesSlice.reducer;
